import ArticlesApi from '../../api/Articles';
import { ERROR_TYPES } from '../../constants/ApiErrorConstants';
import { selectKnowledgeBase } from '../../knowledge-base/selectors/knowledgeBaseDetails';
import { getEditorUrl } from '../../routing/utils/externalUrls';
import { getEditArticlePath } from '../../routing/utils/internalPaths';
import { getIsUngatedForLocalizedArticleTitle } from '../../selectors/gates';
import { getDefaultArticleName } from '../../utils/articleUtils';
import * as ActionTypes from '../ActionTypes';
import { push } from '../HistoryActions';
import { showErrorNotification } from '../Notifications';
import { getShouldCallSCPEndpoints } from '../../migration-handler/singleton/migrationHandler';
function articleCreated() {
  return {
    type: ActionTypes.CREATE_ARTICLE_SUCCESS
  };
}
function articleCreating() {
  return {
    type: ActionTypes.CREATE_ARTICLE_PENDING
  };
}
function articleCreateRequestFailed(error) {
  return {
    error,
    type: ActionTypes.CREATE_ARTICLE_ERROR
  };
}
export function createArticle() {
  return (dispatch, getState) => {
    const currentKBId = selectKnowledgeBase(getState()).id;
    dispatch(articleCreating());
    return ArticlesApi.create({
      values: {
        hs_name: getDefaultArticleName(!!getShouldCallSCPEndpoints(currentKBId) && getIsUngatedForLocalizedArticleTitle(getState())),
        hs_group_id: currentKBId
      }
    }).then(response => {
      if ('id' in response) {
        dispatch(push(getEditArticlePath(response.id)));
        dispatch(articleCreated());
      } else {
        window.location.href = getEditorUrl(response.values.hs_id);
      }
    }, error => {
      const stringKey = error.responseJSON && ERROR_TYPES.CREATE_ARTICLE_ERROR_TYPES.includes(error.responseJSON.errorType) ? error.responseJSON.errorType : 'default';
      dispatch(showErrorNotification(`createArticle.${stringKey}`));
      dispatch(articleCreateRequestFailed(error));
    });
  };
}